"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viaArrowKeys = void 0;
var chai_1 = require("chai");
var utils_1 = require("@time-input-polyfill/utils");
function viaArrowKeys(utils) {
    var $input = utils.$input, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, loadPrimaryInput = utils.loadPrimaryInput, use = utils.use;
    describe('Segment Navigation - via Arrow keys', function () {
        it('hours [->] minutes', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .then(use.rightArrow)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'minutes';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes));
        });
        it('minutes [->] mode', function () {
            loadPrimaryInput({ segment: 'minutes' })
                .then(use.rightArrow)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'mode';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .then(a11yHasExpectedHtml(a11yInitialHtml().mode));
        });
        it('mode [->] mode', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.rightArrow)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'mode';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .then(a11yHasExpectedHtml(a11yInitialHtml().mode));
        });
        it('mode [<-] minutes', function () {
            loadPrimaryInput({ segment: 'mode' })
                .then(use.leftArrow)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'minutes';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes));
        });
        it('minutes [<-] hours', function () {
            loadPrimaryInput({ segment: 'minutes' })
                .then(use.leftArrow)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'hrs12';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .then(a11yHasExpectedHtml(a11yInitialHtml().hrs12));
        });
        it('hours [<-] hours', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .then(use.leftArrow)
                .then(function (jQueryInputElem) {
                var segment = (0, utils_1.getCursorSegment)($input(jQueryInputElem));
                var expectation = 'hrs12';
                (0, chai_1.expect)(segment).to.eq(expectation);
                return jQueryInputElem;
            })
                .then(a11yHasExpectedHtml(a11yInitialHtml().hrs12));
        });
    });
}
exports.viaArrowKeys = viaArrowKeys;
